import { CONSTANTS } from "client/utils/constants";
import { useNavigate, useParams } from "react-router";
import { GetStatusIcon } from "client/utils/IconsUtil";
import { useDispatch, useSelector } from "react-redux";
import selectors from "redux/Navigation/selectors";
import { useEffect, useState } from "react";
import { operations } from "redux/Navigation";
import OrderDetailViewBreadcrumb from "./OrderDetailViewBreadcrumb";
import { setOrderById } from "Store/OrderManagement/Order/OrderAction"

const OrderDetailViewBreadcrumbContainer = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { headerNav }: any = useSelector((state: any) => ({
        headerNav: selectors.GetHeaderNav(state),
    }));
    const navDispatch = operations.dispatchNav(dispatch);
    const [headerNavItem, setHeaderNavItem] = useState("home");

    let { pagename, activeassetnumber } = useParams();
    
    useEffect(() => {
        setHeaderNavItem(headerNav);
    }, [headerNav]);

    const breadcrumlist = [
        {
          text: pagename == 'activeasset' ? "Active Assets Drill Through" : headerNavItem ===  "Customer My Orders" ? "Requests" : headerNavItem,
          key: "f1",
          href: "/ordermanagement",
          onClick: (e: any) => {
            e.preventDefault();
            if(pagename === CONSTANTS.PAGE_NAME.REQUISITION){
              navDispatch('Customer My Orders')
            } else if(pagename === CONSTANTS.BULK_ORDER){
              navDispatch('Bulk Orders')
            } else if(pagename == 'activeasset'){
              navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
            } else{
              navDispatch('Home')
            }
            if(pagename != 'activeasset'){
            navigate('/ordermanagement');
            }
          },
        },
        { text: "Order Detail", key: "f4" },
      ];
    
      const handleClickBack = () => {
        if(pagename === CONSTANTS.PAGE_NAME.REQUISITION){
          navDispatch('Customer My Orders')
        } else if(pagename === CONSTANTS.BULK_ORDER){
          navDispatch('Bulk Orders')
        } else if(pagename == 'activeasset'){
          navigate('/ordermanagement/activeasset/activeassetdashboard/' + activeassetnumber)
        } else{
          navDispatch('Home')
        }
        dispatch(setOrderById({}))
        if(pagename != 'activeasset'){
        navigate('/ordermanagement');
        }
      }

      const iconReturn = (status: any) => {
        let src = GetStatusIcon(status)?.icon;
        return src;
      };

      const { orderDetails }: any = useSelector((state: any) => ({
        orderDetails: state.OrderReducer.orderByIdData
      }));

    return(
        <OrderDetailViewBreadcrumb breadcrumlist={breadcrumlist} handleClickBack={handleClickBack} iconReturn={iconReturn}
        pagename={pagename} orderDetails={orderDetails}/>
    )
}

export default OrderDetailViewBreadcrumbContainer